/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { ComIbmCommerceSchedulerBeansJobStatusListDataBeanIBMAdminSummary } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * JobStatusApi - axios parameter creator
 * @export
 */
export const JobStatusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary findJobStatuses.
         * @param {string} storeId The store identifier.
         * @param {string} [jobId] jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeStoreIdJobStatusGet: async (storeId: string, jobId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('storeStoreIdJobStatusGet', 'storeId', storeId)
            const localVarPath = `/store/{storeId}/job_status`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (jobId !== undefined) {
                localVarQueryParameter['jobId'] = jobId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobStatusApi - functional programming interface
 * @export
 */
export const JobStatusApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobStatusApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary findJobStatuses.
         * @param {string} storeId The store identifier.
         * @param {string} [jobId] jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeStoreIdJobStatusGet(storeId: string, jobId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComIbmCommerceSchedulerBeansJobStatusListDataBeanIBMAdminSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeStoreIdJobStatusGet(storeId, jobId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * JobStatusApi - factory interface
 * @export
 */
export const JobStatusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobStatusApiFp(configuration)
    return {
        /**
         * 
         * @summary findJobStatuses.
         * @param {string} storeId The store identifier.
         * @param {string} [jobId] jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeStoreIdJobStatusGet(storeId: string, jobId?: string, options?: any): AxiosPromise<ComIbmCommerceSchedulerBeansJobStatusListDataBeanIBMAdminSummary> {
            return localVarFp.storeStoreIdJobStatusGet(storeId, jobId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobStatusApi - object-oriented interface
 * @export
 * @class JobStatusApi
 * @extends {BaseAPI}
 */
export class JobStatusApi extends BaseAPI {
    /**
     * 
     * @summary findJobStatuses.
     * @param {string} storeId The store identifier.
     * @param {string} [jobId] jobId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobStatusApi
     */
    public storeStoreIdJobStatusGet(storeId: string, jobId?: string, options?: any) {
        return JobStatusApiFp(this.configuration).storeStoreIdJobStatusGet(storeId, jobId, options).then((request) => request(this.axios, this.basePath));
    }
}
